export default {
  stripImageDataFromJson(json) {
    try {
      let str;
      str = JSON.stringify(json);
      str = str.replaceAll(/\\"data:image\/.*?"/g, '\\"(base64 image values have been omitted)\\"');
      str = str.replaceAll(/"data:image\/.*?"/g, '"(base64 image values have been omitted)"');
      str = str.replaceAll(/\\"data:audio\/.*?"/g, '\\"(base64 audio values have been omitted)\\"');
      str = str.replaceAll(/"data:audio\/.*?"/g, '"(base64 audio values have been omitted)"');
      return JSON.parse(str);
    } catch (e) {
      return json;
    }
  },
  isJson(json) {
    try {
      JSON.parse(json);
      return true;
    } catch (e) {
      return false;
    }
  },
};
